import { createSelector } from '@reduxjs/toolkit';
import { CandleValidation } from 'client/voladeum/candle-validations/types';
import { RootState } from 'store';

const candleValidationsSlice = (state: RootState) => state.candle_validations;

export const selectCandleValidations = createSelector(
  [candleValidationsSlice],
  (state): CandleValidation[] => state
);
